export default "__VITE_ASSET__Dg4JsNCY__"